/**
 * Une seule règle pour dire l'échec d'une requête — audit 2026-09-23 (A6).
 *
 * React Query 3 GARDE `data` quand un rechargement de fond échoue. Lire `isError`
 * brut remplaçait donc un écran lisible par une alerte (c'était le cas du tableau
 * de bord). L'échec ne se dit que s'il n'y a rien à lire ; une donnée présente,
 * même vide, reste affichée.
 */
export function echecSansDonnee(q: { isError: boolean; data: unknown }): boolean {
    return q.isError && q.data === undefined;
}
